/** Season destination at signup (classement / team / tournament), not SMART ★/· objectives. */
export const COMPETITION_OBJECTIVE_KINDS = [
  { id: "classement" },
  { id: "team_championship" },
  { id: "tournament" },
  { id: "other" },
];

/** Legacy ranking chips — kept for older profiles that stored a target classement. */
export const FINAL_OBJECTIVE_CLASSMENTS = [
  "A1",
  "A2",
  "A3",
  "B1",
  "B2",
  "B3",
  "C1",
  "C2",
  "C3",
  "D",
];

export function composeFinalObjectiveLabel({
  kinds = [],
  kind = null,
  customText,
  targetClassement,
  teamGoal,
  optionLabels = {},
  t,
} = {}) {
  const selected = (Array.isArray(kinds) && kinds.length ? kinds : kind ? [kind] : [])
    .map((id) => String(id || "").trim())
    .filter(Boolean);
  if (selected.length) {
    const bits = selected
      .map((id) => {
        if (id === "other") return String(customText || "").trim();
        return (
          optionLabels[id] ||
          (t ? t(`smartFinalObjectiveKind_${id}`, { defaultValue: id }) : "")
        );
      })
      .filter(Boolean);
    if (bits.length) return bits.join(" · ");
  }
  const rank = String(targetClassement || "").trim();
  const team = String(teamGoal || "").trim();
  if (rank && team) {
    return t
      ? t("smartFinalObjectiveComposed", { rank, team })
      : `Reach ${rank} and help my team get promoted to ${team}.`;
  }
  if (rank) {
    return t ? t("smartFinalObjectiveRankOnly", { rank }) : `Reach ${rank}.`;
  }
  if (team) {
    return t ? t("smartFinalObjectiveTeamOnly", { team }) : `Help my team get promoted to ${team}.`;
  }
  return "";
}

export function composePhaseObjectiveLabel({
  primaryLabel,
  secondaryLabels = [],
  finalLabel,
  t,
} = {}) {
  const axes = [primaryLabel, ...(secondaryLabels || []).filter(Boolean)]
    .map((s) => String(s || "").trim())
    .filter(Boolean);
  const axesText = axes.join(" + ");
  const dest = String(finalLabel || "").trim();
  if (!axesText) return dest || "";
  if (t) {
    return dest
      ? t("smartPhaseObjectiveToward", { axes: axesText, dest })
      : t("smartPhaseObjective", { axes: axesText });
  }
  const core = `By mid-season, improve ${axesText} so I can apply them consistently in matches, tracking weekly measurable indicators`;
  return dest ? `${core} — toward ${dest}.` : `${core}.`;
}
